// @flow
import { useContext } from 'react';
import { useMutation, MutationOptions } from 'react-query';
import { saveShortFormData } from 'services/formService';
import { AppContext } from 'contexts/AppContext';

const useSaveShortFormMutation = ({
  options,
}: {
  options: MutationOptions,
} = {}) => {
  const { organizationId, propertyId } = useContext(AppContext);

  return useMutation(
    async ({ applicantId, ...payload }) => {
      return saveShortFormData({
        organizationId,
        propertyId,
        applicantId,
        payload,
      });
    },
    {
      ...options,
      enabled: Boolean(organizationId && propertyId),
    },
  );
};

export default useSaveShortFormMutation;
